import { useTranslate } from "@refinedev/core";
import { Space, Typography, Checkbox } from "antd";
import { useVolatileBoundStore } from "store";

export const HighlightRankFilter = () => {
  const { highlightRanks, setHighlightRanks } = useVolatileBoundStore(
    (state) => ({
      highlightRanks: state.storyboardState.highlightRanks,
      setHighlightRanks: state.setHighlightRanks,
    })
  );
  const t = useTranslate();
  const ranksCheckboxOptions = [
    { label: 0, value: 0 },
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: ">5", value: 5 },
  ];

  const defaultChecked = highlightRanks ?? [0, 1, 2, 3, 4, 5];
  return (
    <Space>
      <Typography.Text>
        {t("components.storyboard.StoryboardEditor.showRank")}
      </Typography.Text>
      <Checkbox.Group
        options={ranksCheckboxOptions}
        value={defaultChecked}
        onChange={setHighlightRanks}
      />
    </Space>
  );
};
